import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { RequisitionCardActionsModalComponent } from 'src/app/pages/mission-control-page/requisitions-page/requisition-card/requisition-card-actions-modal/requisition-card-actions-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RequisitionCardActionsModalService {

  requisitionCardActionsModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(modalData: any, refreshCardCallback?: () => void): void {
    const config = new ModalConfig();
    config.class = modalData.windowTopClass || 'custom-ngx-modal custom-ngx-feedback-form-modal';
    config.initialState = modalData;
    config.ignoreBackdropClick = true;
    this.requisitionCardActionsModal = this.bsModalService.show(RequisitionCardActionsModalComponent, config);
    this.requisitionCardActionsModal.content.onClose.subscribe((result: any) => {
      if (result && refreshCardCallback) {
        refreshCardCallback();
      }
    });
  }
}
